import React from 'react';
import { NavLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { Wrapper, ImageWrap, ShopText, ExtraText } from './styled';

import BannerStartV5Desk from '@assets/images/start-banner-v5-desktop.svg';
import BannerStartV5Mob from '@assets/images/start-banner-v5-mobile.svg';

import { getSpaUrl } from '@config/getEnviroment';

import { SHOPS_PARTICIPANTS } from '@utils/router';
import { ViewModeWidth } from '@helpers/viewModeHelper';

const LegacyStart = () => {
  const { t } = useTranslation();
  const url = getSpaUrl();
  const isMinSM = useMediaQuery({
    minWidth: ViewModeWidth.SM,
  });

  return (
    <Wrapper>
      <a href={url} target="_top">
        <ImageWrap>
          {isMinSM ? <img src={BannerStartV5Desk} alt="" /> : <img src={BannerStartV5Mob} alt="" />}
        </ImageWrap>
      </a>
      <ShopText>
        <Trans
          i18nKey="legacy.urls.start.shop"
          components={{
            link1: (
              <NavLink to={SHOPS_PARTICIPANTS} target="_blank">
                {t('legacy.component.footer.SHOPS_PARTICIPANTS')}
              </NavLink>
            ),
          }}
        />
      </ShopText>
      <ExtraText>{t('legacy.urls.start.extra')}</ExtraText>
    </Wrapper>
  );
};

export default LegacyStart;
